import { render, staticRenderFns } from "./BioSearchView.vue?vue&type=template&id=4953e6a9&scoped=true&"
import script from "./BioSearchView.vue?vue&type=script&lang=js&"
export * from "./BioSearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953e6a9",
  null
  
)

export default component.exports